export default __webpack_public_path__ + "static/banner4-229c3e8a44ebfe4d86803ca654436c1d.png";